import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * Shows an "Install app" button when the browser fires beforeinstallprompt.
 * Lets users add SendOccasions to their home screen (PWA install).
 */
export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!localStorage.getItem("so_install_dismissed")) setVisible(true);
    };
    const onInstalled = () => { setVisible(false); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!visible || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    try { await deferred.userChoice; } catch (e) {}
    setVisible(false);
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem("so_install_dismissed", "1");
    setVisible(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-md nb-card nb-shadow-lg p-3 flex items-center gap-3 bg-[#F9F871] animate-pop-in" data-testid="install-prompt">
      <div className="w-10 h-10 grid place-items-center rounded-xl border-2 border-[#0A0A0A] bg-[#FFB5A7] shrink-0">
        <Download className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold leading-tight">Install SendOccasions</div>
        <div className="text-xs text-[#4A4A4A]">Add to your home screen for one-tap access.</div>
      </div>
      <button onClick={install} data-testid="install-app-btn" className="nb-btn bg-white px-4 py-2 text-sm shrink-0">Install</button>
      <button onClick={dismiss} aria-label="Dismiss" className="w-8 h-8 grid place-items-center rounded-lg border-2 border-[#0A0A0A] bg-white shrink-0"><X className="w-4 h-4" /></button>
    </div>
  );
}
